import { combineReducers } from 'redux'
import authorizedLayoutReducer, { INITIAL_STATE as AUTHORIZED_LAYOUT_INITIAL_STATE } from './authorized-layout.reducer'
import instantFeedbackReducer from './instant-feedback.reducer'
import adminReducer, { INITIAL_STATE as ADMIN_INITIAL_STATE } from './admin.reducer'
import assignmentsReducer, { INITIAL_STATE as ASSIGNMENTS_INITIAL_STATE } from './assignments.reducer'
import assignmentReducer, { INITIAL_STATE as ASSIGNMENT_INITIAL_STATE } from './assignment.reducer'
import authReducer, { INITIAL_STATE as AUTH_INITIAL_STATE } from './auth.reducer'
import compareSnippetsReducer, { INITIAL_STATE as COMPARE_SNIPPETS_INITIAL_STATE } from './compare-snippets.reducer'
import unitTestsReducer, { INITIAL_STATE as UNIT_TESTS_INITIAL_STATE } from './unit-tests.reducer'
import globalReducer, { INITIAL_STATE as GLOBAL_INITIAL_STATE } from './global.reducer'
import problemSetsSlice from '../slices/problem-sets.slice'
import { logoutUser } from '../middlewares/logoutMiddleware'
import assignmentSlice from '../slices/assignment.slice'
import assignmentsPersistSlice from '../slices/assignments.persist.slice'
import instantFeedbackSlice from '../slices/instant-feedback.slice'
import submissionSlice from '../slices/submission.slice'
import catalogItemSlice from '../slices/catalog-item.slice'
import cartSlice from '../slices/cart.slice'
import patternSlice from '../slices/pattern.slice'
import textSubmissionDrawerSlice from '../slices/text-submission-drawer.slice'
import questionSlice from '../slices/question.slice'
import baseApi from '../apis/base.api'
import groupSlice from '../slices/group.slice'
import userSlice from '../slices/user.slice'
import rubricPersistSlice from '../slices/rubric.persist.slice'
import authPersistSlice from '../slices/auth.persist.slice'
import themeSlice from '../slices/theme.slice'
import conceptualLabelSlice from '../slices/conceptual-label.slice'
import rubricRefinementSlice from '../slices/rubric-refinement.slice'
import rubricSlice from '../slices/rubric.slice'
import referenceReasoningsSlice from '../slices/reference-reasonings.slice'
import disciplineSlice from '../slices/discipline.slice'
import feedbackTrackingSlice from '../slices/feedback-tracking.slice'
import textInstantFeedbackSlice from '../slices/text-instant-feedback.slice'

const createAppReducer = () =>
    combineReducers({
        [baseApi.reducerPath]: baseApi.reducer,
        authorizedLayout: authorizedLayoutReducer,
        auth: authReducer,
        authPersist: authPersistSlice,
        theme: themeSlice,
        admin: adminReducer,
        assignments: assignmentsReducer,
        assignmentsPersist: assignmentsPersistSlice,
        rubricPersist: rubricPersistSlice,
        rubricRefinement: rubricRefinementSlice,
        rubric: rubricSlice,
        assignment: assignmentReducer,
        catalogItem: catalogItemSlice,
        conceptualLabel: conceptualLabelSlice,
        discipline: disciplineSlice,
        submission: submissionSlice,
        group: groupSlice,
        question: questionSlice,
        instantFeedback: instantFeedbackReducer,
        instantFeedbackSlice: instantFeedbackSlice, // to be renamed to 'instantFeedback' when fully migrated to RTK and got rid of native 'instantFeedback' reducer
        compareSnippets: compareSnippetsReducer,
        unitTests: unitTestsReducer,
        global: globalReducer,
        textSubmissionDrawer: textSubmissionDrawerSlice,
        problemSets: problemSetsSlice,
        assignmentSlice: assignmentSlice, // to be renamed to 'assignment' when fully migrated to RTK and got rid of native 'assignment' reducer
        cart: cartSlice,
        pattern: patternSlice,
        user: userSlice,
        referenceReasonings: referenceReasoningsSlice,
        feedbackTracking: feedbackTrackingSlice,
        textInstantFeedback: textInstantFeedbackSlice,
    })

const initialState = {
    authorizedLayout: AUTHORIZED_LAYOUT_INITIAL_STATE,
    auth: { ...AUTH_INITIAL_STATE, isWaitingForGetCurrentUser: false },
    admin: ADMIN_INITIAL_STATE,
    assignments: ASSIGNMENTS_INITIAL_STATE,
    assignment: ASSIGNMENT_INITIAL_STATE,
    compareSnippets: COMPARE_SNIPPETS_INITIAL_STATE,
    unitTests: UNIT_TESTS_INITIAL_STATE,
    global: GLOBAL_INITIAL_STATE,
}

const createRootReducer = () => (state, action) => {
    if (action.type === logoutUser.type) {
        // Resetting native redux reducers - to be removed when fully migrated to RTK
        const cleanedStateFromUserData = {
            ...initialState,
            instantFeedback: state.instantFeedback, // instant feedback is the only page that does not require authorization
            theme: state.theme, // preserve theme preference across logout
        }
        return createAppReducer()(cleanedStateFromUserData, action)
    }
    return createAppReducer()(state, action)
}

export default createRootReducer
